import { useState } from "react";
import Layout from "../components/Layout";
import Button from "../components/Button";
import LoginModal from "../components/LoginModal";

export default function NeedLoginLayoutStub({ text }) {
  const [loginOpen, setLoginOpen] = useState(false);
  return (
    <Layout>
      {loginOpen ? (
        <LoginModal
          allowBackgroundDimiss
          onSuccess={() => setLoginOpen(false)}
          onBackgroundDismiss={() => setLoginOpen(false)}
        />
      ) : null}
      <p className="text-center text-lg text-white">
        {text}
        <div className="mt-4">
          <Button onClick={() => setLoginOpen(true)} size="huge">
            Log in or create an account
          </Button>
        </div>
      </p>
    </Layout>
  );
}
